import {
  AnalyticsPieIcon,
  BankTransferIcon,
  CashPaymentBillIcon,
  CreditCardIcon,
  PlantPotIcon,
  QuestionCircleIcon,
} from '@flywire/icons';
import { useQuery } from '@tanstack/react-query';
import { sourceOfFunds } from 'services/payex/sourceOfFunds/sourceOfFunds';
type SourceOfFundsMap = Record<
  string,
  {
    name: string;
    financialInstitutions: {
      name: string;
    }[];
  }
>;

const useSourceOfFunds = () => {
  return useQuery(
    ['sourceOfFundsIndia'],
    async () => {
      const response = await sourceOfFunds.get();

      return response.reduce((acc, item) => {
        acc[item.name] = item;
        return acc;
      }, {} as SourceOfFundsMap);
    },
    {
      refetchInterval: false,
    },
  );
};

const sourceOfFundsIcons = {
  savings: PlantPotIcon,
  loan: CashPaymentBillIcon,
  education_loan_and_savings: AnalyticsPieIcon,
  other: CreditCardIcon,
};

const financialInstitutionsIcons = {
  avanse: QuestionCircleIcon,
  credila: QuestionCircleIcon,
  hdfc: QuestionCircleIcon,
  icici: QuestionCircleIcon,
  sbi: QuestionCircleIcon,
  otherBanks: BankTransferIcon,
  otherNBFCs: BankTransferIcon,
};

export {
  useSourceOfFunds,
  type SourceOfFundsMap,
  sourceOfFundsIcons,
  financialInstitutionsIcons,
};
